// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Modern AI-Style Courses Page */

.Courses-main {
    min-height: calc(100vh - 80px);
    padding: 40px 60px;
    background: #ffffff;
    position: relative;
    margin-top: 60px;
}

.disabledCard {
  filter: grayscale(100%);
  opacity: 0.4;
  cursor: not-allowed;
  pointer-events: none;
}

/* Header Section */
.coursesHeader {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 40px;
    position: relative;
    z-index: 1;
    flex-wrap: wrap;
    gap: 24px;
    animation: fadeInUp 0.6s ease-out;
}

.coursesHeaderContent {
    display: flex;
    align-items: center;
    gap: 24px;
    flex: 1 1;
}

.coursesHeaderIconWrapper {
    width: 70px;
    height: 70px;
    background: rgba(102, 126, 234, 0.1);
    border-radius: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid rgba(102, 126, 234, 0.2);
    box-shadow: 0 4px 12px rgba(102, 126, 234, 0.15);
    transition: all 0.3s ease;
    flex-shrink: 0;
}

.coursesHeaderIconWrapper:hover {
    transform: translateY(-5px) scale(1.05);
    box-shadow: 0 8px 24px rgba(102, 126, 234, 0.2);
}

.coursesHeaderIcon {
    font-size: 36px !important;
    color: #667eea !important;
}

.coursesMainTitle {
    font-size: 42px;
    font-weight: 700;
    color: #1f2937;
    margin: 0 0 8px 0;
    line-height: 1.2;
    letter-spacing: -0.5px;
}

.coursesSubtitle {
    font-size: 16px;
    color: #6b7280;
    margin: 0;
    line-height: 1.6;
    font-weight: 400;
}

/* Enhanced Search Wrapper */
.coursesSearchWrapper {
    position: relative;
    z-index: 1;
    min-width: 400px;
}

.coursesSearchInput {
    width: 100%;
}

.coursesSearchInput.ant-input-affix-wrapper {
    background: rgba(255, 255, 255, 0.95);
    -webkit-backdrop-filter: blur(20px);
            backdrop-filter: blur(20px);
    border-radius: 12px;
    border: 1px solid rgba(102, 126, 234, 0.2);
    padding: 12px 16px;
    height: 48px;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
    transition: all 0.3s ease;
}

.coursesSearchInput.ant-input-affix-wrapper:hover {
    border-color: #667eea;
    box-shadow: 0 6px 20px rgba(102, 126, 234, 0.15);
}

.coursesSearchInput.ant-input-affix-wrapper-focused {
    border-color: #667eea;
    box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}

.coursesSearchInput .ant-input {
    background: transparent;
    font-size: 15px;
    color: #1f2937;
}

.coursesSearchInput .ant-input::placeholder {
    color: #9ca3af;
}

.searchIconPrefix {
    color: #667eea !important;
    font-size: 20px !important;
    margin-right: 8px;
}

.coursesSearchInput .ant-input-clear-icon {
    color: #9ca3af;
    font-size: 14px;
    transition: all 0.2s ease;
}

.coursesSearchInput .ant-input-clear-icon:hover {
    color: #667eea;
}

/* Loader */
.coursesLoader {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 400px;
    position: relative;
    z-index: 1;
}

/* Content Section */
.coursesContent {
    position: relative;
    z-index: 1;
    animation: fadeInUp 0.8s ease-out 0.2s both;
}

/* Courses Grid */
.coursesGrid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(260px, 1fr)); 
    gap: 20px; 
    margin-bottom: 40px;
}

/* Course Card */
.courseCard {
    background: rgba(255, 255, 255, 0.95) !important;
    -webkit-backdrop-filter: blur(20px);
            backdrop-filter: blur(20px);
    border: 1px solid rgba(255, 255, 255, 0.3) !important;
    border-radius: 20px !important;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1) !important;
    overflow: hidden;
    transition: all 0.3s ease !important;
    cursor: pointer;
}

.courseCard:hover {
    transform: translateY(-6px) scale(1.015)!important;
    box-shadow: 0 16px 48px rgba(102, 126, 234, 0.25) !important;
    border-color: rgba(102, 126, 234, 0.4) !important;
}

.courseCardCover {
    position: relative;
    height: 160px;
    overflow: hidden;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
}

.courseCardOverlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.4);
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: 0;
    transition: all 0.3s ease;
}

.courseCard:hover .courseCardOverlay {
    opacity: 1;
}

.playIcon {
    font-size: 64px !important;
    color: rgba(255, 255, 255, 0.95) !important;
    transition: all 0.3s ease;
}

.courseCard:hover .playIcon {
    transform: scale(1.1);
}

.courseCardImage {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: all 0.3s ease;
}

.courseCard:hover .courseCardImage {
    transform: scale(1.1);
}

.courseCardContent {
    padding: 18px;
}

.courseCardHeader {
    display: flex;
    align-items: flex-start;
    gap: 12px;
    margin-bottom: 12px;
}

.courseCardIcon {
    font-size: 24px !important;
    color: #667eea !important;
    margin-top: 2px;
    flex-shrink: 0;
}

.CareerProgram-main .courseCardTitle {
    font-size: 16px;
    font-weight: 600;
    color: #1f2937;
    margin: 0;
    line-height: 1.35;
    flex: 1 1;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
}

.courseCompletedTag {
    margin-bottom: 12px;
    font-weight: 600;
}

.courseCardFooter {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-top: 12px;
    border-top: 1px solid rgba(0, 0, 0, 0.06);
}

.courseCardAction {
    font-size: 14px;
    font-weight: 600;
    color: #667eea;
    transition: all 0.3s ease;
}

.courseCard:hover .courseCardAction {
    color: #764ba2;
}

.courseCardArrow {
    font-size: 20px !important;
    color: #667eea !important;
    transition: all 0.3s ease;
}

.courseCard:hover .courseCardArrow {
    transform: translateX(4px);
    color: #764ba2 !important;
}

/* Pagination Styles */
.coursesPagination {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 40px 0 20px 0;
    animation: fadeInUp 0.6s ease-out;
}

.coursesPagination .ant-pagination {
    display: flex;
    align-items: center;
    gap: 8px;
}

.coursesPagination .ant-pagination-item {
    min-width: 40px;
    height: 40px;
    line-height: 38px;
    border-radius: 10px;
    border: 1px solid rgba(102, 126, 234, 0.2);
    background: rgba(255, 255, 255, 0.95);
    transition: all 0.3s ease;
    font-weight: 500;
}

.coursesPagination .ant-pagination-item:hover {
    border-color: #667eea;
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(102, 126, 234, 0.15);
}

.coursesPagination .ant-pagination-item-active {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    border-color: transparent;
    font-weight: 600;
}

.coursesPagination .ant-pagination-item-active a {
    color: white;
}

.coursesPagination .ant-pagination-item a {
    color: #1f2937;
    transition: color 0.3s ease;
}

.coursesPagination .ant-pagination-item:hover a {
    color: #667eea;
}

.coursesPagination .ant-pagination-prev,
.coursesPagination .ant-pagination-next {
    min-width: 40px;
    height: 40px;
    line-height: 38px;
    border-radius: 10px;
    border: 1px solid rgba(102, 126, 234, 0.2);
    background: rgba(255, 255, 255, 0.95);
    transition: all 0.3s ease;
}

.coursesPagination .ant-pagination-prev:hover,
.coursesPagination .ant-pagination-next:hover {
    border-color: #667eea;
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(102, 126, 234, 0.15);
}

.coursesPagination .ant-pagination-prev .ant-pagination-item-link,
.coursesPagination .ant-pagination-next .ant-pagination-item-link {
    color: #667eea;
    border: none;
    background: transparent;
}

.coursesPagination .ant-pagination-disabled {
    opacity: 0.4;
    cursor: not-allowed;
}

.coursesPagination .ant-pagination-disabled:hover {
    transform: none;
    box-shadow: none;
    border-color: rgba(102, 126, 234, 0.2);
}

.coursesPagination .ant-pagination-total-text {
    color: #6b7280;
    font-size: 14px;
    font-weight: 500;
    margin-right: 16px;
}

/* Empty State */
.coursesEmptyState {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 400px;
    background: rgba(255, 255, 255, 0.95);
    -webkit-backdrop-filter: blur(20px);
            backdrop-filter: blur(20px);
    border-radius: 20px;
    border: 1px solid rgba(255, 255, 255, 0.3);
    padding: 40px;
}

/* Animations */
@keyframes fadeInUp {
    from {
        opacity: 0;
        transform: translateY(30px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

/* Responsive Design */
@media (max-width: 1200px) {
    .Courses-main {
        padding: 30px 40px;
    }

    .coursesGrid {
        grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
        gap: 20px;
    }

    .coursesSearchWrapper {
        min-width: 350px;
    }
}

@media (max-width: 768px) {
    .Courses-main {
        padding: 30px 20px;
    }

    .coursesHeader {
        flex-direction: column;
        align-items: flex-start;
    }

    .coursesHeaderContent {
        width: 100%;
    }

    .coursesHeaderIconWrapper {
        width: 60px;
        height: 60px;
    }

    .coursesHeaderIcon {
        font-size: 30px !important;
    }

    .coursesMainTitle {
        font-size: 32px;
    }

    .coursesSubtitle {
        font-size: 14px;
    }

    .coursesSearchWrapper {
        width: 100%;
        min-width: unset;
    }

    .coursesSearchInput {
        width: 100% !important;
    }

    .coursesGrid {
        grid-template-columns: 1fr;
        gap: 16px;
    }

    .courseCardCover {
        height: 180px;
    }

    .coursesPagination {
        padding: 30px 0 10px 0;
    }

    .coursesPagination .ant-pagination-item,
    .coursesPagination .ant-pagination-prev,
    .coursesPagination .ant-pagination-next {
        min-width: 36px;
        height: 36px;
        line-height: 34px;
    }
}

@media (max-width: 480px) {
    .Courses-main {
        padding: 20px 16px;
    }

    .coursesMainTitle {
        font-size: 28px;
    }

    .courseCardContent {
        padding: 20px;
    }

    .coursesSearchInput.ant-input-affix-wrapper {
        font-size: 14px !important;
        height: 44px !important;
        padding: 10px 14px;
    }
    
    .searchIconPrefix {
        font-size: 18px !important;
    }
}

.disabledAssessment {
  opacity: 0.5;
  cursor: not-allowed;
}

/* Breadcrumb */
.coursesBreadcrumb {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 20px;
    font-size: 14px;
    font-weight: 500;
    color: #6b7280;
}

.breadcrumbLink {
    color: #667eea;
    cursor: pointer;
    transition: all 0.2s ease;
}

.breadcrumbLink:hover {
    color: #764ba2;
    text-decoration: underline;
}

.breadcrumbSeparator {
    color: #9ca3af;
}

.breadcrumbCurrent {
    color: #1f2937;
    font-weight: 600;
}

`, "",{"version":3,"sources":["webpack://./src/Components/CareerProgram/CareerProgram.css"],"names":[],"mappings":"AAAA,iCAAiC;;AAEjC;IACI,8BAA8B;IAC9B,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA,mBAAmB;AACnB;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,UAAU;IACV,eAAe;IACf,SAAS;IACT,iCAAiC;AACrC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,SAAO;AACX;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,oCAAoC;IACpC,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,0CAA0C;IAC1C,gDAAgD;IAChD,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,uCAAuC;IACvC,+CAA+C;AACnD;;AAEA;IACI,0BAA0B;IAC1B,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,iBAAiB;IACjB,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,cAAc;IACd,SAAS;IACT,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA,4BAA4B;AAC5B;IACI,kBAAkB;IAClB,UAAU;IACV,gBAAgB;AACpB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,qCAAqC;IACrC,mCAA2B;YAA3B,2BAA2B;IAC3B,mBAAmB;IACnB,0CAA0C;IAC1C,kBAAkB;IAClB,YAAY;IACZ,0CAA0C;IAC1C,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,gDAAgD;AACpD;;AAEA;IACI,qBAAqB;IACrB,8CAA8C;AAClD;;AAEA;IACI,uBAAuB;IACvB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,0BAA0B;IAC1B,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,cAAc;AAClB;;AAEA,WAAW;AACX;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;IAClB,UAAU;AACd;;AAEA,oBAAoB;AACpB;IACI,kBAAkB;IAClB,UAAU;IACV,2CAA2C;AAC/C;;AAEA,iBAAiB;AACjB;IACI,aAAa;IACb,4DAA4D;IAC5D,SAAS;IACT,mBAAmB;AACvB;;AAEA,gBAAgB;AAChB;IACI,gDAAgD;IAChD,mCAA2B;YAA3B,2BAA2B;IAC3B,qDAAqD;IACrD,8BAA8B;IAC9B,oDAAoD;IACpD,gBAAgB;IAChB,oCAAoC;IACpC,eAAe;AACnB;;AAEA;IACI,kDAAkD;IAClD,4DAA4D;IAC5D,iDAAiD;AACrD;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,gBAAgB;IAChB,6DAA6D;AACjE;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,8BAA8B;IAC9B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,UAAU;IACV,yBAAyB;AAC7B;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,0BAA0B;IAC1B,2CAA2C;IAC3C,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,0BAA0B;IAC1B,yBAAyB;IACzB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,SAAS;IACT,iBAAiB;IACjB,SAAO;IACP,oBAAoB;IACpB,qBAAqB;IACrB,aAAa;IACb,4BAA4B;IAC5B,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,iBAAiB;IACjB,yCAAyC;AAC7C;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,0BAA0B;IAC1B,yBAAyB;IACzB,yBAAyB;AAC7B;;AAEA;IACI,0BAA0B;IAC1B,yBAAyB;AAC7B;;AAEA,sBAAsB;AACtB;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,sBAAsB;IACtB,iCAAiC;AACrC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,iBAAiB;IACjB,mBAAmB;IACnB,0CAA0C;IAC1C,qCAAqC;IACrC,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;IACrB,2BAA2B;IAC3B,gDAAgD;AACpD;;AAEA;IACI,6DAA6D;IAC7D,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,2BAA2B;AAC/B;;AAEA;IACI,cAAc;AAClB;;AAEA;;IAEI,eAAe;IACf,YAAY;IACZ,iBAAiB;IACjB,mBAAmB;IACnB,0CAA0C;IAC1C,qCAAqC;IACrC,yBAAyB;AAC7B;;AAEA;;IAEI,qBAAqB;IACrB,2BAA2B;IAC3B,gDAAgD;AACpD;;AAEA;;IAEI,cAAc;IACd,YAAY;IACZ,uBAAuB;AAC3B;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,sCAAsC;AAC1C;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA,gBAAgB;AAChB;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,iBAAiB;IACjB,qCAAqC;IACrC,mCAA2B;YAA3B,2BAA2B;IAC3B,mBAAmB;IACnB,0CAA0C;IAC1C,aAAa;AACjB;;AAEA,eAAe;AACf;IACI;QACI,UAAU;QACV,2BAA2B;IAC/B;IACA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;;AAEA,sBAAsB;AACtB;IACI;QACI,kBAAkB;IACtB;;IAEA;QACI,4DAA4D;QAC5D,SAAS;IACb;;IAEA;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,kBAAkB;IACtB;;IAEA;QACI,sBAAsB;QACtB,uBAAuB;IAC3B;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,WAAW;QACX,gBAAgB;IACpB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,0BAA0B;QAC1B,SAAS;IACb;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;;;QAGI,eAAe;QACf,YAAY;QACZ,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,kBAAkB;IACtB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,0BAA0B;QAC1B,uBAAuB;QACvB,kBAAkB;IACtB;;IAEA;QACI,0BAA0B;IAC9B;AACJ;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,eAAe;AACf;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,0BAA0B;AAC9B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB","sourcesContent":["/* Modern AI-Style Courses Page */\n\n.Courses-main {\n    min-height: calc(100vh - 80px);\n    padding: 40px 60px;\n    background: #ffffff;\n    position: relative;\n    margin-top: 60px;\n}\n\n.disabledCard {\n  filter: grayscale(100%);\n  opacity: 0.4;\n  cursor: not-allowed;\n  pointer-events: none;\n}\n\n/* Header Section */\n.coursesHeader {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 40px;\n    position: relative;\n    z-index: 1;\n    flex-wrap: wrap;\n    gap: 24px;\n    animation: fadeInUp 0.6s ease-out;\n}\n\n.coursesHeaderContent {\n    display: flex;\n    align-items: center;\n    gap: 24px;\n    flex: 1;\n}\n\n.coursesHeaderIconWrapper {\n    width: 70px;\n    height: 70px;\n    background: rgba(102, 126, 234, 0.1);\n    border-radius: 20px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border: 1px solid rgba(102, 126, 234, 0.2);\n    box-shadow: 0 4px 12px rgba(102, 126, 234, 0.15);\n    transition: all 0.3s ease;\n    flex-shrink: 0;\n}\n\n.coursesHeaderIconWrapper:hover {\n    transform: translateY(-5px) scale(1.05);\n    box-shadow: 0 8px 24px rgba(102, 126, 234, 0.2);\n}\n\n.coursesHeaderIcon {\n    font-size: 36px !important;\n    color: #667eea !important;\n}\n\n.coursesMainTitle {\n    font-size: 42px;\n    font-weight: 700;\n    color: #1f2937;\n    margin: 0 0 8px 0;\n    line-height: 1.2;\n    letter-spacing: -0.5px;\n}\n\n.coursesSubtitle {\n    font-size: 16px;\n    color: #6b7280;\n    margin: 0;\n    line-height: 1.6;\n    font-weight: 400;\n}\n\n/* Enhanced Search Wrapper */\n.coursesSearchWrapper {\n    position: relative;\n    z-index: 1;\n    min-width: 400px;\n}\n\n.coursesSearchInput {\n    width: 100%;\n}\n\n.coursesSearchInput.ant-input-affix-wrapper {\n    background: rgba(255, 255, 255, 0.95);\n    backdrop-filter: blur(20px);\n    border-radius: 12px;\n    border: 1px solid rgba(102, 126, 234, 0.2);\n    padding: 12px 16px;\n    height: 48px;\n    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);\n    transition: all 0.3s ease;\n}\n\n.coursesSearchInput.ant-input-affix-wrapper:hover {\n    border-color: #667eea;\n    box-shadow: 0 6px 20px rgba(102, 126, 234, 0.15);\n}\n\n.coursesSearchInput.ant-input-affix-wrapper-focused {\n    border-color: #667eea;\n    box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);\n}\n\n.coursesSearchInput .ant-input {\n    background: transparent;\n    font-size: 15px;\n    color: #1f2937;\n}\n\n.coursesSearchInput .ant-input::placeholder {\n    color: #9ca3af;\n}\n\n.searchIconPrefix {\n    color: #667eea !important;\n    font-size: 20px !important;\n    margin-right: 8px;\n}\n\n.coursesSearchInput .ant-input-clear-icon {\n    color: #9ca3af;\n    font-size: 14px;\n    transition: all 0.2s ease;\n}\n\n.coursesSearchInput .ant-input-clear-icon:hover {\n    color: #667eea;\n}\n\n/* Loader */\n.coursesLoader {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    min-height: 400px;\n    position: relative;\n    z-index: 1;\n}\n\n/* Content Section */\n.coursesContent {\n    position: relative;\n    z-index: 1;\n    animation: fadeInUp 0.8s ease-out 0.2s both;\n}\n\n/* Courses Grid */\n.coursesGrid {\n    display: grid;\n    grid-template-columns: repeat(auto-fill, minmax(260px, 1fr)); \n    gap: 20px; \n    margin-bottom: 40px;\n}\n\n/* Course Card */\n.courseCard {\n    background: rgba(255, 255, 255, 0.95) !important;\n    backdrop-filter: blur(20px);\n    border: 1px solid rgba(255, 255, 255, 0.3) !important;\n    border-radius: 20px !important;\n    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1) !important;\n    overflow: hidden;\n    transition: all 0.3s ease !important;\n    cursor: pointer;\n}\n\n.courseCard:hover {\n    transform: translateY(-6px) scale(1.015)!important;\n    box-shadow: 0 16px 48px rgba(102, 126, 234, 0.25) !important;\n    border-color: rgba(102, 126, 234, 0.4) !important;\n}\n\n.courseCardCover {\n    position: relative;\n    height: 160px;\n    overflow: hidden;\n    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n}\n\n.courseCardOverlay {\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background: rgba(0, 0, 0, 0.4);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    opacity: 0;\n    transition: all 0.3s ease;\n}\n\n.courseCard:hover .courseCardOverlay {\n    opacity: 1;\n}\n\n.playIcon {\n    font-size: 64px !important;\n    color: rgba(255, 255, 255, 0.95) !important;\n    transition: all 0.3s ease;\n}\n\n.courseCard:hover .playIcon {\n    transform: scale(1.1);\n}\n\n.courseCardImage {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n    transition: all 0.3s ease;\n}\n\n.courseCard:hover .courseCardImage {\n    transform: scale(1.1);\n}\n\n.courseCardContent {\n    padding: 18px;\n}\n\n.courseCardHeader {\n    display: flex;\n    align-items: flex-start;\n    gap: 12px;\n    margin-bottom: 12px;\n}\n\n.courseCardIcon {\n    font-size: 24px !important;\n    color: #667eea !important;\n    margin-top: 2px;\n    flex-shrink: 0;\n}\n\n.CareerProgram-main .courseCardTitle {\n    font-size: 16px;\n    font-weight: 600;\n    color: #1f2937;\n    margin: 0;\n    line-height: 1.35;\n    flex: 1;\n    display: -webkit-box;\n    -webkit-line-clamp: 2;\n    line-clamp: 2;\n    -webkit-box-orient: vertical;\n    overflow: hidden;\n}\n\n.courseCompletedTag {\n    margin-bottom: 12px;\n    font-weight: 600;\n}\n\n.courseCardFooter {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding-top: 12px;\n    border-top: 1px solid rgba(0, 0, 0, 0.06);\n}\n\n.courseCardAction {\n    font-size: 14px;\n    font-weight: 600;\n    color: #667eea;\n    transition: all 0.3s ease;\n}\n\n.courseCard:hover .courseCardAction {\n    color: #764ba2;\n}\n\n.courseCardArrow {\n    font-size: 20px !important;\n    color: #667eea !important;\n    transition: all 0.3s ease;\n}\n\n.courseCard:hover .courseCardArrow {\n    transform: translateX(4px);\n    color: #764ba2 !important;\n}\n\n/* Pagination Styles */\n.coursesPagination {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    padding: 40px 0 20px 0;\n    animation: fadeInUp 0.6s ease-out;\n}\n\n.coursesPagination .ant-pagination {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n}\n\n.coursesPagination .ant-pagination-item {\n    min-width: 40px;\n    height: 40px;\n    line-height: 38px;\n    border-radius: 10px;\n    border: 1px solid rgba(102, 126, 234, 0.2);\n    background: rgba(255, 255, 255, 0.95);\n    transition: all 0.3s ease;\n    font-weight: 500;\n}\n\n.coursesPagination .ant-pagination-item:hover {\n    border-color: #667eea;\n    transform: translateY(-2px);\n    box-shadow: 0 4px 12px rgba(102, 126, 234, 0.15);\n}\n\n.coursesPagination .ant-pagination-item-active {\n    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n    border-color: transparent;\n    font-weight: 600;\n}\n\n.coursesPagination .ant-pagination-item-active a {\n    color: white;\n}\n\n.coursesPagination .ant-pagination-item a {\n    color: #1f2937;\n    transition: color 0.3s ease;\n}\n\n.coursesPagination .ant-pagination-item:hover a {\n    color: #667eea;\n}\n\n.coursesPagination .ant-pagination-prev,\n.coursesPagination .ant-pagination-next {\n    min-width: 40px;\n    height: 40px;\n    line-height: 38px;\n    border-radius: 10px;\n    border: 1px solid rgba(102, 126, 234, 0.2);\n    background: rgba(255, 255, 255, 0.95);\n    transition: all 0.3s ease;\n}\n\n.coursesPagination .ant-pagination-prev:hover,\n.coursesPagination .ant-pagination-next:hover {\n    border-color: #667eea;\n    transform: translateY(-2px);\n    box-shadow: 0 4px 12px rgba(102, 126, 234, 0.15);\n}\n\n.coursesPagination .ant-pagination-prev .ant-pagination-item-link,\n.coursesPagination .ant-pagination-next .ant-pagination-item-link {\n    color: #667eea;\n    border: none;\n    background: transparent;\n}\n\n.coursesPagination .ant-pagination-disabled {\n    opacity: 0.4;\n    cursor: not-allowed;\n}\n\n.coursesPagination .ant-pagination-disabled:hover {\n    transform: none;\n    box-shadow: none;\n    border-color: rgba(102, 126, 234, 0.2);\n}\n\n.coursesPagination .ant-pagination-total-text {\n    color: #6b7280;\n    font-size: 14px;\n    font-weight: 500;\n    margin-right: 16px;\n}\n\n/* Empty State */\n.coursesEmptyState {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    min-height: 400px;\n    background: rgba(255, 255, 255, 0.95);\n    backdrop-filter: blur(20px);\n    border-radius: 20px;\n    border: 1px solid rgba(255, 255, 255, 0.3);\n    padding: 40px;\n}\n\n/* Animations */\n@keyframes fadeInUp {\n    from {\n        opacity: 0;\n        transform: translateY(30px);\n    }\n    to {\n        opacity: 1;\n        transform: translateY(0);\n    }\n}\n\n/* Responsive Design */\n@media (max-width: 1200px) {\n    .Courses-main {\n        padding: 30px 40px;\n    }\n\n    .coursesGrid {\n        grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));\n        gap: 20px;\n    }\n\n    .coursesSearchWrapper {\n        min-width: 350px;\n    }\n}\n\n@media (max-width: 768px) {\n    .Courses-main {\n        padding: 30px 20px;\n    }\n\n    .coursesHeader {\n        flex-direction: column;\n        align-items: flex-start;\n    }\n\n    .coursesHeaderContent {\n        width: 100%;\n    }\n\n    .coursesHeaderIconWrapper {\n        width: 60px;\n        height: 60px;\n    }\n\n    .coursesHeaderIcon {\n        font-size: 30px !important;\n    }\n\n    .coursesMainTitle {\n        font-size: 32px;\n    }\n\n    .coursesSubtitle {\n        font-size: 14px;\n    }\n\n    .coursesSearchWrapper {\n        width: 100%;\n        min-width: unset;\n    }\n\n    .coursesSearchInput {\n        width: 100% !important;\n    }\n\n    .coursesGrid {\n        grid-template-columns: 1fr;\n        gap: 16px;\n    }\n\n    .courseCardCover {\n        height: 180px;\n    }\n\n    .coursesPagination {\n        padding: 30px 0 10px 0;\n    }\n\n    .coursesPagination .ant-pagination-item,\n    .coursesPagination .ant-pagination-prev,\n    .coursesPagination .ant-pagination-next {\n        min-width: 36px;\n        height: 36px;\n        line-height: 34px;\n    }\n}\n\n@media (max-width: 480px) {\n    .Courses-main {\n        padding: 20px 16px;\n    }\n\n    .coursesMainTitle {\n        font-size: 28px;\n    }\n\n    .courseCardContent {\n        padding: 20px;\n    }\n\n    .coursesSearchInput.ant-input-affix-wrapper {\n        font-size: 14px !important;\n        height: 44px !important;\n        padding: 10px 14px;\n    }\n    \n    .searchIconPrefix {\n        font-size: 18px !important;\n    }\n}\n\n.disabledAssessment {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n/* Breadcrumb */\n.coursesBreadcrumb {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    margin-bottom: 20px;\n    font-size: 14px;\n    font-weight: 500;\n    color: #6b7280;\n}\n\n.breadcrumbLink {\n    color: #667eea;\n    cursor: pointer;\n    transition: all 0.2s ease;\n}\n\n.breadcrumbLink:hover {\n    color: #764ba2;\n    text-decoration: underline;\n}\n\n.breadcrumbSeparator {\n    color: #9ca3af;\n}\n\n.breadcrumbCurrent {\n    color: #1f2937;\n    font-weight: 600;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
